export default {
      id: "icon--freestyle-usage",
      viewBox: "0 0 32 22",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--freestyle-usage",
      toString: function () {
        return this.url;
      }
    }